import React from "react";
import PropTypes from "prop-types";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import TrackBox from "./TrackBox";

const TrackBoxes = ({ tracks, lg, md }) => (
  <Row>
    {tracks &&
      tracks.map((track) => {
        return (
          <Col xs={12} sm={6} md={md} lg={lg} key={track.id}>
            <TrackBox track={track} />
          </Col>
        );
      })}
  </Row>
);

TrackBoxes.propTypes = {
  tracks: PropTypes.array.isRequired,
  lg: PropTypes.number,
  md: PropTypes.number,
};

TrackBoxes.defaultProps = {
  lg: 4,
  md: 6,
};

export default TrackBoxes;
